import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        ok: '&',
        cancel: '&'
    },
    template: `
    <div class="modal-header">
        <button type="button" class="close" ng-click="vm.cancel()"></button>
        <h2>{{ 'questionCategory.Add category' | translate }}</h2>
    </div>
    <form ng-submit="vm.save()">
        <div class="modal-body">
            <div class="form">
                <forms-settings-questioncategories-generaldata form="vm.form"></forms-settings-questioncategories-generaldata>
            </div>
        </div>
        <div class="modal-footer" >
            <ul class="actions01">
                <li class="primary"><input type="submit" class="btn main" value="{{ 'general.Save' | translate }}"/></li>
                <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    </form>
    `
})
export default class {
    constructor (FormFactory, QuestionCategoryResource) {
        this.form = FormFactory.create(new QuestionCategoryResource, model => model.$save());
    }

    save () {
        this.form.save()
            .then(() => {
                this.ok();
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/questioncategories/add/index.js